import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../_services/auth.service';
import {ContentService} from '../_services/content.service';

export const roleGuard: CanActivateFn = (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);
    const contentService: ContentService = inject(ContentService);

    if (authService.isSuperUser() || contentService.userHasCommunityRole(route.data['communityRoles'])) {
        return true;
    }
    router.navigate(['/404']);
    return false;
};
